import { useEffect, useReducer, useState } from "react";
/**
 * Model-View-Update hook.
 * Ensures good practices by separating your state management from your side effects.
 */
function useMVU(defaultModel, update, notify) {
    var _a = useState([]), effects = _a[0], setEffects = _a[1];
    function reducer(model, action) {
        var _a = update(model, action), nextModel = _a[0], nextEffects = _a[1];
        setEffects(nextEffects);
        return nextModel;
    }
    var _b = useReducer(reducer, defaultModel), model = _b[0], dispatch = _b[1];
    useEffect(function () {
        if (effects.length > 0) {
            effects.forEach(function (eff) { return notify(eff, model, dispatch); });
            setEffects([]);
        }
    }, [effects, model, notify]);
    return dispatch;
}
export default useMVU;
//# sourceMappingURL=mvu.js.map